<script>
  import { recettes } from "../../store/RecettesStore";
  import { onMount } from "svelte";
  import { pop } from "svelte-spa-router";

  let data;
  export let params = {};

  /**
   * recupere le parazm passer via l url
   */
  const getID = () => {
    return params.id;
  };

  /**
   * . retourn l'element correspondant à l'id ds l ob jet JSON
   * @param data
   */
  const OneRecette = (id) => {
    let result = [];
    for (var i = 1; i <= $recettes.length; i++) {
      if (i == id) {
        //console.log($recettes[i - 1]);
        return $recettes[i - 1];
      }
    }
    return {};
  };

  onMount(async () => {
    data = OneRecette(getID());
  });
</script>

<button on:click={() => pop()}>back</button>

{#if data}
  {#await data then}
    <h3>{data.titre}</h3>
    <h4 class="bg-primary">Ingrédients</h4>
    <ul class="list-group">
      {#each data.ingredients as elemt}
        <li class="list-group-item">
          <input class="form-check-input me-1" type="checkbox" />
          <span class="poids">{elemt.poids}</span><span class="nom">
            {elemt.nom}</span
          >
        </li>
      {/each}
    </ul>
    <h4 class="bg-warning">Commentaires</h4>
    <ol class="list-group list-group-numbered comment">
      {#each data.commentaire as ligne}
        <li class="list-group-item">{ligne.ligne}</li>
      {/each}
    </ol>
  {:catch}
    <strong>Erreur : Fiche rechette non trouvée</strong>
  {/await}
{/if}

<style>
  ol li {
    line-height: 5px;
  }
  .poids {
    font-weight: bold;
  }
  .nom {
    padding-left: 5px;
  }
  .comment {
    font-size: 0.8em;
  }
</style>
